export const CF_REPORTS_SUCCESS = "CF_REPORTS_SUCCESS";
export const CF_REPORTS_FAILURE = "CF_REPORTS_FAILURE";

export const MTM_REPORTS_SUCCESS = "MTM_REPORTS_SUCCESS";
export const VAR_REPORTS_SUCCESS = "VAR_REPORTS_SUCCESS";
export const ALERTS_SUCCESS = "ALERTS_SUCCESS";
export const SUMMARY_SUCCESS = "SUMMARY_SUCCESS";
export const SLICES_SUCCESS = "SLICES_SUCCESS";
export const INSTRUMENT_SUCCESS = "INSTRUMENT_SUCCESS";
export const INSTRUMENT_SUMMARY_SUCCESS = "INSTRUMENT_SUMMARY_SUCCESS";
export const CORRESPONDENT_SUCCESS = "CORRESPONDENT_SUCCESS";

export const MTM_REPORTS_FAILURE = "MTM_REPORTS_FAILURE";
export const VAR_REPORTS_FAILURE = "VAR_REPORTS_FAILURE";
export const ALERTS_FAILURE = "ALERTS_FAILURE";
export const SUMMARY_FAILURE = "SUMMARY_FAILURE";
export const SLICES_FAILURE = "SLICES_FAILURE";
export const INSTRUMENT_FAILURE = "INSTRUMENT_FAILURE";
export const INSTRUMENT_SUMMARY_FAILURE = "INSTRUMENT_SUMMARY_FAILURE";
export const CORRESPONDENT_FAILURE = "CORRESPONDENT_FAILURE";

export const FAILURE = "FAILURE";
export const REPORTS_REQUEST = "REPORTS_REQUEST";
export const SLICES_REQUEST = "SLICES_REQUEST";
export const ALERTS_REQUEST = "ALERTS_REQUEST";
export const SUMMARY_REQUEST = "SUMMARY_REQUEST";
export const INSTRUMENT_REQUEST = "INSTRUMENT_REQUEST";
export const SET_SLICE = "SET_SLICE";
export const SET_SUMMARY_DATE = "SET_SUMMARY_DATE";
export const SET_TKR_CUSIP = "SET_TKR_CUSIP";
export const PROJECTED_VAR_REPORTS_SUCCESS = "PROJECTED_VAR_REPORTS_SUCCESS";
export const PROJECTED_VAR_REPORTS_FAILURE = "PROJECTED_VAR_REPORTS_FAILURE";
